var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        size: "lg",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "no-fade": "",
        "no-stacking": "",
        centered: ""
      },
      on: {
        shown: _vm.loadPaymentData,
        hide: () => {
          _vm.gettingPaymentInfo = true
        }
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function() {
            return [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "pr-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "icon-button",
                            "data-test-hook": "back-button-payment-modal"
                          },
                          on: {
                            click: function($event) {
                              return _vm.goToPreviousSubscriptionModal()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "fas fa-chevron-left back-chevron-button"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _c("b-col", [
                    _c("h2", { staticClass: "modal-title" }, [
                      _c("i", {
                        staticClass: "fal fa-credit-card colorOrange mr-1"
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("xPaymentInformation")))
                    ])
                  ])
                ],
                1
              )
            ]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _vm.useExistingBillingInfo
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        block: "",
                        disabled: !_vm.canPay() || _vm.paying,
                        "data-test-hook": "PayBtn"
                      },
                      on: {
                        click: function($event) {
                          _vm.$v.$touch(), _vm.payForProduct()
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("xPayNow")) + " "),
                      _vm.paying
                        ? _c("b-spinner", { staticClass: "ml-2" })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.useExistingBillingInfo && !_vm.isShowingValidationView
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "outline-warning",
                        block: "",
                        "data-test-hook": "confirm-billing-info-button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.addBillingAddress()
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("xConfirmBillingInfo")) + " "),
                      _vm.savingAccountHolder
                        ? _c("b-spinner", {
                            staticClass: "ml-2",
                            attrs: { small: "" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.useExistingBillingInfo &&
              _vm.isShowingValidationView &&
              !_vm.showContactSupportButton
                ? _c(
                    "b-row",
                    { staticClass: "w-100 m-0", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "pr-1" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "secondary",
                                block: "",
                                "data-test-hook": "edit-address-button"
                              },
                              on: { click: _vm.editAddress }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("xAddressSearchEditAddress")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "pl-1" },
                        [
                          _c(
                            "b-button",
                            {
                              staticStyle: { "justify-content": "center" },
                              attrs: {
                                variant: "warning",
                                block: "",
                                disabled: _vm.confirmAddressDisabled,
                                "data-test-hook": "confirm-address-button"
                              },
                              on: { click: _vm.confirmAddress }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("xAddressSearchConfirmAddress")
                                  ) +
                                  " "
                              ),
                              _vm.savingAddress
                                ? _c(
                                    "span",
                                    [_c("b-spinner", { attrs: { small: "" } })],
                                    1
                                  )
                                : _c("span", [
                                    _c("i", {
                                      staticClass: "far fa-arrow-right"
                                    })
                                  ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.useExistingBillingInfo &&
              _vm.isShowingValidationView &&
              _vm.showContactSupportButton
                ? _c(
                    "b-row",
                    { staticClass: "w-100 m-0", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "pr-1" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "secondary",
                                block: "",
                                "data-test-hook": "edit-address-button"
                              },
                              on: { click: _vm.editAddress }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("xAddressSearchEditAddress")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "pl-1" },
                        [
                          !_vm.useExistingBillingInfo &&
                          _vm.isShowingValidationView &&
                          _vm.showContactSupportButton
                            ? _c(
                                "b-button",
                                {
                                  staticStyle: { "justify-content": "center" },
                                  attrs: {
                                    variant: "warning",
                                    block: "",
                                    "data-test-hook": "contact-support-button"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$router.push({
                                        path: `/support`
                                      })
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("xContactSupport")) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "b-alert",
        {
          attrs: { show: _vm.showCreditCardValidationBanner, variant: "danger" }
        },
        [
          _c("p", [
            _c("i", { staticClass: "mr-2 fa-light fa-circle-exclamation" }),
            _vm._v(" " + _vm._s(_vm.$t("xExperiencedTheseErrors")) + " ")
          ]),
          _vm._l(_vm.errorMessages, function(message, index) {
            return _c("ul", { key: index, staticClass: "ml-2" }, [
              _c("li", { attrs: { id: index } }, [
                _vm._v(" " + _vm._s(message) + " ")
              ])
            ])
          })
        ],
        2
      ),
      _c(
        "b-alert",
        {
          staticClass: "alert alert-danger",
          attrs: { show: _vm.addressSearchError }
        },
        [
          _c("h4", { staticClass: "alert-heading" }, [
            _vm._v(_vm._s(_vm.$t("xSomethingWentWrong")))
          ]),
          _c("p", { staticClass: "alert-body" }, [
            _vm._v(_vm._s(_vm.$t("xWaitAndTryAgainErrorText")))
          ])
        ]
      ),
      _vm.gettingPaymentInfo
        ? _c(
            "div",
            [
              _c(
                "b-col",
                { staticClass: "float-center text-center" },
                [
                  _c("b-spinner", {
                    staticStyle: { width: "10rem", height: "10rem" },
                    attrs: { variant: "primary", label: "Spinning" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c("div", [
            !_vm.isShowingValidationView
              ? _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c("h2", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("xCreditCardInfo")))
                            ])
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm.existingPaymentInfo
                      ? _c(
                          "div",
                          [
                            !_vm.useExistingPaymentInfo
                              ? _c(
                                  "b-row",
                                  { staticClass: "mb-2" },
                                  [
                                    _c("b-col", { attrs: { cols: "12" } }, [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("xUpdatingPaymentWarning")
                                          )
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    attrs: {
                                      "data-test-hook": "CreditCardCheckbox"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        model: {
                                          value: _vm.useExistingPaymentInfo,
                                          callback: function($$v) {
                                            _vm.useExistingPaymentInfo = $$v
                                          },
                                          expression: "useExistingPaymentInfo"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "xUseCurrentCreditCardInformation"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm.useExistingPaymentInfo
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "mt-3" },
                                      [
                                        _c("b-col", { attrs: { cols: "12" } }, [
                                          _c("p", [
                                            _c("strong", [
                                              _c("i", {
                                                staticClass:
                                                  "fal fa-credit-card"
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.existingPaymentInfo
                                                      .cardType
                                                  ) +
                                                  " - " +
                                                  _vm._s(
                                                    _vm.existingPaymentInfo
                                                      .cardSuffix
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          ])
                                        ])
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-row",
                                      [
                                        _c("b-col", { attrs: { cols: "12" } }, [
                                          _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("xExpires")) +
                                                " " +
                                                _vm._s(
                                                  _vm.existingPaymentInfo
                                                    .expirationMonth +
                                                    "/" +
                                                    _vm.existingPaymentInfo
                                                      .expirationYear
                                                ) +
                                                " "
                                            )
                                          ])
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "credit-card-number"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: "################",
                                                      expression:
                                                        "'################'"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "16",
                                                    placeholder: _vm.$t(
                                                      "xCreditCardNumber"
                                                    ),
                                                    state:
                                                      _vm.validState(
                                                        _vm.$v.creditCardNumber
                                                      ) == null ||
                                                      _vm.validState(
                                                        _vm.$v.creditCardNumber
                                                      ) == true
                                                        ? null
                                                        : false,
                                                    "aria-describedby":
                                                      "card-number-invalid"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.$v.creditCardNumber
                                                        .$model,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.$v.creditCardNumber,
                                                        "$model",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "$v.creditCardNumber.$model"
                                                  }
                                                }),
                                                _c(
                                                  "b-form-invalid-feedback",
                                                  {
                                                    attrs: {
                                                      id: "card-number-invalid"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "xCCFieldValidation"
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { md: "4", sm: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "expiry-date-month"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: "##",
                                                      expression: "'##'"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: _vm.$t("xMm"),
                                                    maxlength: "2",
                                                    state:
                                                      _vm.validState(
                                                        _vm.$v.expirationMonth
                                                      ) == null ||
                                                      _vm.validState(
                                                        _vm.$v.expirationMonth
                                                      ) == true
                                                        ? null
                                                        : false,
                                                    "aria-describedby":
                                                      "expiry-month-invalid"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.$v.expirationMonth
                                                        .$model,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.$v.expirationMonth,
                                                        "$model",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "$v.expirationMonth.$model"
                                                  }
                                                }),
                                                _c(
                                                  "b-form-invalid-feedback",
                                                  {
                                                    attrs: {
                                                      id: "expiry-month-invalid"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "xExpirationMonthValidation"
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "4", sm: "12" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "expiry-date-year"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: "##",
                                                      expression: "'##'"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: _vm.$t("xYy"),
                                                    maxlength: "2",
                                                    state:
                                                      _vm.validState(
                                                        _vm.$v.expirationYear
                                                      ) == null ||
                                                      _vm.validState(
                                                        _vm.$v.expirationYear
                                                      ) == true
                                                        ? null
                                                        : false,
                                                    "aria-describedby":
                                                      "expiry-year-invalid"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.$v.expirationYear
                                                        .$model,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.$v.expirationYear,
                                                        "$model",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "$v.expirationYear.$model"
                                                  }
                                                }),
                                                _c(
                                                  "b-form-invalid-feedback",
                                                  {
                                                    attrs: {
                                                      id: "expiry-year-invalid"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "xExpirationYearValidation"
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "4", sm: "12" } },
                                          [
                                            _c(
                                              "b-input-group",
                                              { attrs: { id: "cvv" } },
                                              [
                                                _c("b-form-input", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: "####",
                                                      expression: "'####'"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "4",
                                                    placeholder: _vm.$t("xCvv"),
                                                    state:
                                                      _vm.validState(
                                                        _vm.$v.cvv
                                                      ) == null ||
                                                      _vm.validState(
                                                        _vm.$v.cvv
                                                      ) == true
                                                        ? null
                                                        : false,
                                                    "aria-describedby":
                                                      "cvv-invalid"
                                                  },
                                                  model: {
                                                    value: _vm.$v.cvv.$model,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.$v.cvv,
                                                        "$model",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "$v.cvv.$model"
                                                  }
                                                }),
                                                _c(
                                                  "b-input-group-append",
                                                  [
                                                    _c(
                                                      "b-input-group-text",
                                                      [
                                                        _c("b-img", {
                                                          attrs: {
                                                            height: 20,
                                                            src: require("@/assets/images/3-digit-code.svg")
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-form-invalid-feedback",
                                                  {
                                                    attrs: { id: "cvv-invalid" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "xCVVValidation"
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c("b-col", { attrs: { cols: "12" } }, [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$t("xUpdatingPaymentWarning"))
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      { attrs: { id: "credit-card-number" } },
                                      [
                                        _c("b-form-input", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "################",
                                              expression: "'################'"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            maxlength: "16",
                                            placeholder: _vm.$t(
                                              "xCreditCardNumber"
                                            ),
                                            state:
                                              _vm.validState(
                                                _vm.$v.creditCardNumber
                                              ) == null ||
                                              _vm.validState(
                                                _vm.$v.creditCardNumber
                                              ) == true
                                                ? null
                                                : false,
                                            "aria-describedby":
                                              "card-number-invalid"
                                          },
                                          model: {
                                            value:
                                              _vm.$v.creditCardNumber.$model,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.$v.creditCardNumber,
                                                "$model",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "$v.creditCardNumber.$model"
                                          }
                                        }),
                                        _c(
                                          "b-form-invalid-feedback",
                                          {
                                            attrs: { id: "card-number-invalid" }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("xCCFieldValidation")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "4", sm: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      { attrs: { id: "expiry-date-month" } },
                                      [
                                        _c("b-form-input", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "##",
                                              expression: "'##'"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.$t("xMm"),
                                            maxlength: "2",
                                            state:
                                              _vm.validState(
                                                _vm.$v.expirationMonth
                                              ) == null ||
                                              _vm.validState(
                                                _vm.$v.expirationMonth
                                              ) == true
                                                ? null
                                                : false,
                                            "aria-describedby":
                                              "expiry-month-invalid"
                                          },
                                          model: {
                                            value:
                                              _vm.$v.expirationMonth.$model,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.$v.expirationMonth,
                                                "$model",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "$v.expirationMonth.$model"
                                          }
                                        }),
                                        _c(
                                          "b-form-invalid-feedback",
                                          {
                                            attrs: {
                                              id: "expiry-month-invalid"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xExpirationMonthValidation"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "4", sm: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      { attrs: { id: "expiry-date-year" } },
                                      [
                                        _c("b-form-input", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "##",
                                              expression: "'##'"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.$t("xYy"),
                                            maxlength: "2",
                                            state:
                                              _vm.validState(
                                                _vm.$v.expirationYear
                                              ) == null ||
                                              _vm.validState(
                                                _vm.$v.expirationYear
                                              ) == true
                                                ? null
                                                : false,
                                            "aria-describedby":
                                              "expiry-year-invalid"
                                          },
                                          model: {
                                            value: _vm.$v.expirationYear.$model,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.$v.expirationYear,
                                                "$model",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "$v.expirationYear.$model"
                                          }
                                        }),
                                        _c(
                                          "b-form-invalid-feedback",
                                          {
                                            attrs: { id: "expiry-year-invalid" }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xExpirationYearValidation"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { md: "4", sm: "12" } },
                                  [
                                    _c(
                                      "b-input-group",
                                      { attrs: { id: "cvv" } },
                                      [
                                        _c("b-form-input", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: "####",
                                              expression: "'####'"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            maxlength: "4",
                                            placeholder: _vm.$t("xCvv"),
                                            state:
                                              _vm.validState(_vm.$v.cvv) ==
                                                null ||
                                              _vm.validState(_vm.$v.cvv) == true
                                                ? null
                                                : false,
                                            "aria-describedby": "cvv-invalid"
                                          },
                                          model: {
                                            value: _vm.$v.cvv.$model,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.$v.cvv,
                                                "$model",
                                                $$v
                                              )
                                            },
                                            expression: "$v.cvv.$model"
                                          }
                                        }),
                                        _c(
                                          "b-input-group-append",
                                          [
                                            _c(
                                              "b-input-group-text",
                                              [
                                                _c("b-img", {
                                                  attrs: {
                                                    height: 20,
                                                    src: require("@/assets/images/3-digit-code.svg"),
                                                    id: "ccCvvImage"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-form-invalid-feedback",
                                          { attrs: { id: "cvv-invalid" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("xCVVValidation")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                  ],
                  1
                )
              : _vm._e(),
            _vm.accountData && !_vm.isShowingValidationView
              ? _c(
                  "div",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c("h2", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("xBillingInformationLowercase")) +
                                " "
                            )
                          ])
                        ])
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      { staticClass: "mb-2" },
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  "data-test-hook":
                                    "payment-modal-checkbox-existing-info"
                                },
                                model: {
                                  value: _vm.useExistingBillingInfo,
                                  callback: function($$v) {
                                    _vm.useExistingBillingInfo = $$v
                                  },
                                  expression: "useExistingBillingInfo"
                                }
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("xUseCurrentBillingInfo"))
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.useExistingBillingInfo
                      ? _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _vm._v(
                                _vm._s(_vm.accountProfile.firstName) +
                                  " " +
                                  _vm._s(_vm.accountProfile.lastName)
                              )
                            ]),
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.DisplayAddress(
                                      _vm.accountProfile.address
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            !_vm.useExistingBillingInfo
              ? _c(
                  "div",
                  [
                    !_vm.isShowingValidationView
                      ? _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { lg: "6", md: "6", sm: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  { attrs: { id: "firstName-group" } },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "firstName",
                                        type: "text",
                                        placeholder: _vm.$t("xFirstName"),
                                        state:
                                          _vm.validState(
                                            _vm.$v.accountData.firstName
                                          ) == null ||
                                          _vm.validState(
                                            _vm.$v.accountData.firstName
                                          ) == true
                                            ? null
                                            : false,
                                        "aria-describedby": "firstName-invalid"
                                      },
                                      model: {
                                        value:
                                          _vm.$v.accountData.firstName.$model,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.$v.accountData.firstName,
                                            "$model",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "$v.accountData.firstName.$model"
                                      }
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "invalid-feedback",
                                        attrs: { id: "firstName-invalid" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("xRequiredField")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { lg: "6", md: "6", sm: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  { attrs: { id: "lastName-group" } },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "lastName",
                                        type: "text",
                                        placeholder: _vm.$t("xLastName"),
                                        state:
                                          _vm.validState(
                                            _vm.$v.accountData.lastName
                                          ) == null ||
                                          _vm.validState(
                                            _vm.$v.accountData.lastName
                                          ) == true
                                            ? null
                                            : false,
                                        "aria-describedby": "lastName-invalid"
                                      },
                                      model: {
                                        value:
                                          _vm.$v.accountData.lastName.$model,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.$v.accountData.lastName,
                                            "$model",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "$v.accountData.lastName.$model"
                                      }
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "invalid-feedback",
                                        attrs: { id: "lastName-invalid" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("xRequiredField")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c("AddressSearchModals", {
                              ref: "paymentInformationAddressSearchModalsRef",
                              attrs: {
                                addressSearchModalId:
                                  "payment-information-address-search-form",
                                addressValidationModalId:
                                  "payment-information-address-validation-form",
                                inline: true,
                                showContinueButton: false,
                                showValidationButtons: false,
                                showAddressCheckmarkHeader: false,
                                isBillingAddress: true
                              },
                              on: {
                                onSubmit: _vm.saveAccountHolder,
                                addressSearchModalViewChanged:
                                  _vm.handleValidationStateChange,
                                setIsNextDisabled: _vm.handleSetIsNextDisabled,
                                addressSearchError: _vm.handleAddressSearchError
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _vm.selectedProduct
                      ? _c(
                          "div",
                          [
                            _c(
                              "b-row",
                              { staticClass: "my-3" },
                              [
                                _c("b-col", { attrs: { cols: "12" } }, [
                                  _c(
                                    "div",
                                    { staticClass: "subscription-cost" },
                                    [
                                      _c("h3", { staticClass: "mb-0" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("xTotalPayment")) +
                                            ": " +
                                            _vm._s(
                                              _vm._f("formatCurrency")(
                                                _vm.selectedProduct.cost.toFixed(
                                                  2
                                                )
                                              )
                                            )
                                        )
                                      ]),
                                      _c("p", [
                                        _c("i", [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("xBilled")) +
                                              " "
                                          ),
                                          _vm.selectedProduct
                                            .durationInMonths == 12
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("xYearly"))
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("xMonthly"))
                                                )
                                              ])
                                        ])
                                      ])
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-row",
                      [
                        _c("b-col", [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("xUpdatingCCApplyActiveSubscriptions")
                              )
                            )
                          ])
                        ])
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      { staticClass: "mt-3" },
                      [
                        _c("b-col", [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "xThisSubscriptionWillAutoRenewShortVersion"
                                )
                              )
                            )
                          ])
                        ])
                      ],
                      1
                    ),
                    _c(
                      "b-row",
                      { staticClass: "mt-3" },
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  state: _vm.validState(_vm.$v.consent),
                                  "data-test-hook":
                                    "payment-modal-checkbox-consent"
                                },
                                model: {
                                  value: _vm.$v.consent.$model,
                                  callback: function($$v) {
                                    _vm.$set(_vm.$v.consent, "$model", $$v)
                                  },
                                  expression: "$v.consent.$model"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("xConsentCheckboxText")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.consent == false
                              ? _c("p", { staticClass: "colorRed ml-4" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("xConsentNotCheckedError")
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
          ]),
      _vm.showSavingAccountHolderError
        ? _c(
            "div",
            {
              staticClass: "alert alert--validation alert-danger",
              attrs: { role: "alert", show: _vm.showSavingAccountHolderError }
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("xFailedToUpdateBillingNameAndAddress")) +
                  " "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }